import { useEffect } from "react";
import ProfileHeader from "./ProfileHeader";
import ProfileTabs from "./ProfileTabs";
import useGetData from "../../CustomHooks/useAxios/useGetData";
import { GET_USER } from "../../api/allApi_List";
import DialogBox from "../../components/UI/DialogBox";
import spin from "../../assets/icons/spin.png";
import { handleErrMessage } from "../../functions/handleErrMessage";
import MainPageLayout from "../../layout/MainPageLayout";

const ViewProfilePage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    getData(GET_USER + userId);
  }, []);

  return (
    <MainPageLayout headerConfig={{ title: "Profile" }}>
      {isLoaded && !error ? (
        <div className="profile-container">
          <div className="profileWrap">
            <div className="bg-white">
              <ProfileHeader userData={data} />
            </div>
            <ProfileTabs userData={data} />
          </div>
        </div>
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default ViewProfilePage;
